import React, { useState, useEffect } from "react";
import { JobService } from "../../../../../services/JobService";
import TreeView from "react-treeview";
import $ from "jquery";
import ReactStars from "react-rating-stars-component";
import { toast } from "react-toastify";
import { Link, useParams } from "react-router-dom";

import {
  Row,
  Card,
  CardBody,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Alert,
} from "reactstrap";
import { getEnumLists } from "../../../../../services/MetadataService";

const Skills = (props) => {
  var { id } = useParams();
  const [categories, setCategories] = useState([]);
  const [rating, setRating] = useState(0);
  const [ratingValue, setRatingValue] = useState(0);
  const [selectedSkills, setSelectedSkills] = useState([]);
  const [filteredSkills, setFilteredSkills] = useState([]);

  const [skillid, setskillid] = useState("");
  const [skillname, setskillname] = useState("");
  const [modalRight, setModalRight] = useState(false);
  const [scategories, setSCategories] = useState([]);
  const [languageshow, setlanguageShow] = useState(true);
  const [candidateSkills, setCandidateSkills] = useState([]);
  const [skillSelectedList, setSkillSelectedList] = useState([]);
  const [skillIds, setSkillIds] = useState([]);
  const [jobStatus, setJobStatus] = useState("");
  const [jobSkillLevels, setJobSkillLevels] = useState([]);
  const [treeview, setTreeview] = useState(false);
  const [ratingSelectedList, setRatingSelectedList] = useState([]);

  useEffect(() => {
    getJobEnums();
    getTotalSkillList();
    let jobId = window.localStorage.getItem("requestId");
    if (id != 0) {
      getJobDetails(id);
      getReqSkillList();
    }
  }, []);

  const getJobDetails = (jobId) => {
    var jobDetails = props.jobDetails;
    if (jobDetails != null) {
      if (jobDetails.jobStatus !== null || jobDetails.jobStatus !== "") {
        setJobStatus(jobDetails.jobStatus.key);
      }
    }
  };
  const getJobEnums = () => {
    getEnumLists().then((response) => {
      try {
        if (response !== null) {
          let jobSkillLevels = response.jobSkillLevels;
          if (jobSkillLevels != null) {
            const skillLevel = jobSkillLevels.reverse();
            setJobSkillLevels(skillLevel);
          }
        }
      } catch (err) {}
    });
  };

  const getTotalSkillList = () => {
    JobService.getSkillsService().then((response) => {
      try {
        if (response.message != null) {
          if (response.data.error_message !== "") {
          }
        } else {
          var skillDetails = response.data;
          if (skillDetails != null) {
            setCategories(skillDetails.indlist);
            setFilteredSkills(skillDetails.indlist);

            skillDetails.indlist.length > 0 &&
              skillDetails.indlist.map((industrydetails, index) => {
                industrydetails.categories.length > 0 &&
                  industrydetails.categories.map((category, index) => {
                    category.skills.length > 0 &&
                      category.skills.map((skill, indexval) => {
                        category.skills[indexval].rating = 0;
                        category.skills[indexval].isDisabled = false;
                        category.skills[indexval].skillLevel = "";
                      });
                  });
              });
            setCategories(skillDetails.indlist);
            setFilteredSkills(skillDetails.indlist);
          }
        }
      } catch (err) {}
    });
  };

  const getReqSkillList = () => {
    JobService.getReqSkillService(id).then((response) => {
      try {
        if (response.message != null) {
          if (response.data.error_message !== "") {
          }
        } else {
          if (response.data != null) {
            setCandidateSkills(response.data.skills);
            response.data.skills.length > 0 &&
              response.data.skills.map((skill, index) => {
                if (skill.rating == 0) {
                  setRating(1);
                }
              });
          }
        }
      } catch (err) {}
    });
  };

  const handleCheck = (event, softSkills, categoryId) => {
    var uniqueId = categoryId + "_" + softSkills.skillId;
    var selectedSkillId = softSkills.skillId;

    var updatedList = [...skillSelectedList];
    if (event.target.checked) {
      let skillLevel = "";
      if (jobSkillLevels.length > 0) {
        skillLevel = jobSkillLevels[0].key;
      }

      const skillDetails = {
        skillId: softSkills.skillId,
        categoryId: categoryId,
        skillLevel: skillLevel,
      };
      updatedList.push(skillDetails);

      //   updatedList.push(softSkills.skillId);
      const isFound = selectedSkills.some((element) => {
        if (softSkills.skillId === selectedSkills.skillId) {
          return true;
        }
        return false;
      });
      if (isFound) {
      } else {
        selectedSkills.push({
          skillId: softSkills.skillId,
          skillLevel: $("#" + softSkills.skillId + "_skillLevel").val(),
          rating: 0,
        });

        skillIds.push({
          skillId: softSkills.skillId,
        });
      }

      let selectedRatingList = [...ratingSelectedList];
      if (selectedRatingList.length > 0) {
        for (let i = 0; i < selectedRatingList.length; i++) {
          selectedRatingList[i].isRated = false;
          if (selectedRatingList[i].categoryId == categoryId) {
            if (selectedRatingList[i].uniqueId == uniqueId) {
              selectedRatingList[i].rating = 0;
            }
          }
        }
      }
      setRatingSelectedList(selectedRatingList);
    } else {
      for (let i = 0; i < updatedList.length; i++) {
        if (updatedList[i].categoryId == categoryId) {
          if (updatedList[i].skillId == softSkills.skillId) {
            updatedList.splice(i, 1);
          }
        }
      }
      for (var i = 0; i < selectedSkills.length; i++) {
        if (selectedSkills[i].skillId == softSkills.skillId) {
          selectedSkills.splice(i, 1);
          skillIds.splice(i, 1);
          break;
        }
      }

      const selectedRatingList = [...ratingSelectedList];
      if (selectedRatingList.length > 0) {
        for (let i = 0; i < selectedRatingList.length; i++) {
          selectedRatingList[i].isRated = false;
          if (selectedRatingList[i].categoryId == categoryId) {
            if (selectedRatingList[i].uniqueId == uniqueId) {
              selectedRatingList[i].rating = 0;
            }
          }
        }
      }
      setRatingSelectedList(selectedRatingList);
    }

    for (let i = 0; i < filteredSkills.length; i++) {
      let categories = filteredSkills[i].categories;
      if (categories.length > 0) {
        for (let j = 0; j < categories.length; j++) {
          let skillCategoryId = categories[j].id;
          let skills = categories[j].skills;
          if (skills.length > 0) {
            for (let k = 0; k < skills.length; k++) {
              if (skills[k].skillId == selectedSkillId) {
                if (skillCategoryId == categoryId) {
                  skills[k].isDisabled = false;
                } else {
                  if (event.target.checked) {
                    skills[k].isDisabled = true;
                  } else {
                    skills[k].isDisabled = false;
                    skills[k].skillLevel = "";
                  }
                }
              }
            }
          }
        }
      }
    }
    setSelectedSkills(selectedSkills);
    setSkillSelectedList(updatedList);
    setSkillIds(skillIds);
    setFilteredSkills(filteredSkills);
  };

  const ratingChanged = (newRating, id, categoryId) => {
    let skillRatingList = [...ratingSelectedList];
    if (skillRatingList.length > 0) {
      skillRatingList.map((skillRating) => {
        skillRating.isRated = false;
      });
    }

    var uniqueId = categoryId + "_" + id;
    for (var i = 0; i < selectedSkills.length; i++) {
      if (selectedSkills[i].skillId == id) {
        selectedSkills[i].rating = newRating;
        setRating(newRating);
        break;
      }
    }

    if (skillRatingList.length > 0) {
      const isFound = skillRatingList.some((element) => {
        if (element.categoryId === categoryId) {
          return true;
        }
        return false;
      });

      if (isFound) {
        const isSkillFound = skillRatingList.some((element) => {
          if (element.uniqueId === uniqueId) {
            return true;
          }
          return false;
        });
        if (isSkillFound) {
          for (let i = 0; i < skillRatingList.length; i++) {
            if (skillRatingList[i].categoryId == categoryId) {
              if (skillRatingList[i].uniqueId == uniqueId) {
                skillRatingList[i].skillId = id;
                skillRatingList[i].rating = newRating;
                skillRatingList[i].uniqueId = categoryId + "" + id;
                skillRatingList[i].isRated = true;
              } else {
                skillRatingList[i].isRated = false;
              }
            }
          }
        } else {
          skillRatingList.push({
            skillId: id,
            rating: newRating,
            categoryId: categoryId,
            uniqueId: uniqueId,
            isRated: true,
          });
        }
      } else {
        skillRatingList.push({
          skillId: id,
          rating: newRating,
          categoryId: categoryId,
          uniqueId: uniqueId,
          isRated: true,
        });
      }
    } else {
      skillRatingList.push({
        skillId: id,
        rating: newRating,
        categoryId: categoryId,
        uniqueId: uniqueId,
        isRated: true,
      });
    }
    setRatingSelectedList(skillRatingList);
  };

  function handleSkillLevelChange(e, id, categoryId) {
    var selectedSkillsList=[...selectedSkills];
    for (var i = 0; i < selectedSkillsList.length; i++) {
      if (selectedSkillsList[i].skillId == id) {
        selectedSkillsList[i].skillLevel = e.target.value;
        break;
      }
    }
    setSelectedSkills(selectedSkillsList);

    var updatedList = [...skillSelectedList];
    if (updatedList.length > 0) {
      for (let i = 0; i < updatedList.length; i++) {
        if (updatedList[i].skillId == id) {
          if (updatedList[i].categoryId == categoryId) {
            updatedList[i].skillLevel = e.target.value;
          }
        }
      }
    }
    setSkillSelectedList(updatedList);

    const skillsList = [...filteredSkills];
    for (let i = 0; i < skillsList.length; i++) {
      let categories = skillsList[i].categories;
      if (categories.length > 0) {
        for (let j = 0; j < categories.length; j++) {
          let skillCategoryId = categories[j].id;
          let skills = categories[j].skills;
          if (skills.length > 0) {
            for (let k = 0; k < skills.length; k++) {
              if (skills[k].skillId == id) {
                if (skillCategoryId == categoryId) {
                  skills[k].skillLevel = e.target.value;
                }
              }
            }
          }
        }
      }
    }
    setFilteredSkills(skillsList);
  }

  const ratingUpdatedChanged = (newRating, id) => {
    // setRating(newRating);
    for (var i = 0; i < selectedSkills.length; i++) {
      if (selectedSkills[i].skillId == id) {
        selectedSkills[i].rating = newRating;
        setRatingValue(newRating);
        break;
      }
    }
  };

  const updateSkills = () => {
    const jobId = window.localStorage.getItem("requestId");
    if (id == 0) {
      toast.error("Please fill basic info");
      return;
    }

    if (selectedSkills.length > 0) {
      const skillData = [];
      selectedSkills.map((skill) => {
        for (let j = 0; j < ratingSelectedList.length; j++) {
          if (ratingSelectedList[j].skillId == skill.skillId) {
            skill.rating = ratingSelectedList[j].rating;
          }
        }
        if (skillData.length > 0) {
          const isFound = skillData.some((element) => {
            if (element.skillId === skill.skillId) {
              return true;
            }
            return false;
          });

          if (!isFound) {
            skillData.push({
              skillId: skill.skillId,
              rating: skill.rating,
              skillLevel: skill.skillLevel,
            });
          }
        } else {
          skillData.push({
            skillId: skill.skillId,
            rating: skill.rating,
            skillLevel: skill.skillLevel,
          });
        }
      });

      for (let i = 0; i < skillData.length; i++) {
        if (skillData[i].rating != null) {
          if (skillData[i].rating == 0) {
            toast.error("Please rate your selected skills or unselect them");
            return;
          }
        } else {
          toast.error("Please rate your selected skills or unselect them");
          return;
        }
      }

      const skillObj = {
        skills: skillData,
      };
      JobService.saveJobReqSkillsService(skillObj).then((response) => {
        try {
          var requestId = response.data.id;
          toast.success("Skills added successfully");
          setCandidateSkills([]);
          setModalRight(false);
          getReqSkillList();
        } catch (err) {}
      });
    } else {
      toast.error("Please select skill");
    }
  };

  const searchItems = (searchValue) => {
    setlanguageShow(true);
    if (searchValue !== "") {
      if (searchValue.length >= 3) {
        setTreeview(false);
        JobService.searchSkill(searchValue).then((response) => {
          try {
            if (response.message != null) {
              if (response.data.error_message !== "") {
              }
            } else {
              if (response.data != null) {
               
                response.data.indlist.length > 0 &&               
                  response.data.indlist.map((industrydetails, index) => {
                    industrydetails.categories.length > 0 &&
                      industrydetails.categories.map((category, index) => {
                        category.skills.length > 0 &&
                          category.skills.map((skill, indexval) => {
                            category.skills[indexval].rating = 0;
                            category.skills[indexval].isDisabled = false;
                            category.skills[indexval].skillLevel = "";
                          });
                      });
                  });
                updateSkillDetails(response.data.indlist);
              }
            }
          } catch (err) {}
        });
      } else {
        setTreeview(true);
        updateSkillDetails(categories);
      }
    } else {
      updateSkillDetails(categories);
    }
  };

  const updateSkillDetails = (skillsList) => {

   let selectedcandidateTotSkills = [...candidateSkills];
    if (skillsList.length > 0) {
      skillsList.map((industrydetails, index) => {
        industrydetails.categories.length > 0 &&
          industrydetails.categories.map((category, index) => {
            category.skills.length > 0 &&
              category.skills.map((skill, indexval) => {
                category.skills[indexval].rating = 0;
                category.skills[indexval].isDisabled = false;
                ratingSelectedList.length > 0 &&
                  ratingSelectedList.map((rateskill, indexval1) => {
                    if (rateskill.skillId == skill.skillId) {
                      category.skills[indexval].rating = rateskill.rating;
                    }
                  });
                skillSelectedList.length > 0 &&
                  skillSelectedList.map((selectedSkill, index) => {
                    if (selectedSkill.skillId == skill.skillId) {
                      if (selectedSkill.categoryId == category.id) {
                        //   category.skills[indexval].isDisabled=true
                        category.skills[indexval].skillLevel =
                          selectedSkill.skillLevel;
                      } else {
                        category.skills[indexval].isDisabled = true;
                        // category.skills[indexval].skillLevel = "";
                        category.skills[indexval].skillLevel = selectedSkill.skillLevel;
                      }
                    }
                    // if(sele)
                  });
              });
          });
      });
      setFilteredSkills(skillsList);
    } else {
      setFilteredSkills([]);
    }
  };

  const handleOnChange = (event, option) => {
    var updatedList = [...scategories];
    if (event.target.checked) {
      for (let i = 0; i < updatedList.length; i++) {
        if (updatedList[i].skillId == option.skillId) {
          updatedList[i].isChecked = true;
        }
      }
    } else {
      for (let i = 0; i < updatedList.length; i++) {
        if (updatedList[i].skillId == option.skillId) {
          updatedList[i].isChecked = false;
        }
      }
    }
    setSCategories(updatedList);
  };

  const onAddSkills = () => {
    setRatingSelectedList([]);
    setSkillIds([]);
    setSelectedSkills([]);
    setModalRight(true);
    setSkillSelectedList([]);
    setTreeview(true);
    // resetSkillsList();
    resetSkillsListDetails();
  };

  const resetSkillsListDetails = () => {
    let selectedcandidateTotSkills = [...candidateSkills];
    categories.length > 0 &&
      categories.map((industrydetails, index) => {
        industrydetails.categories.length > 0 &&
          industrydetails.categories.map((category, index) => {
            if (category.skills.length > 0) {
              selectedcandidateTotSkills.map((sSkill, sIndex) => {
                const isFound = category.skills.some((element) => {
                  if (element.skillId === sSkill.skillId) {
                    return true;
                  }
                  return false;
                });
                if (isFound) {
                  sSkill.categoryId = category.id;
                }
              });
              category.skills.map((skill, indexval) => {
                category.skills[indexval].rating = 0;
                category.skills[indexval].isDisabled = false;
              });
            }
          });
      });

    setCategories(categories);
    updateCandidateSkills(selectedcandidateTotSkills, categories);
  };

  const updateCandidateSkills = (candidateSkillList, totalSkills) => {
    var updatedList = [];
    const selectedSkillsList = [...totalSkills];
    const selectedRatingList = [];
    let candidateSelectedSkills = [];

    if (selectedSkillsList.length > 0) {
      selectedSkillsList.map((industrydetails, index) => {
        industrydetails.categories.length > 0 &&
          industrydetails.categories.map((category, index) => {
            category.skills.length > 0 &&
              category.skills.map((skill, indexval) => {
                category.skills[indexval].rating = 0;

                if (candidateSkillList.length > 0) {
                  const isFound = candidateSkillList.some((element) => {
                    if (element.skillId === skill.skillId) {
                      return true;
                    }
                    return false;
                  });

                  if (isFound) {
                    for (let j = 0; j < candidateSkillList.length; j++) {
                      let candidateSkillId = candidateSkillList[j].skillId;
                      let candidateCategoryId =
                        candidateSkillList[j].categoryId;
                      let candidateSkillRating = candidateSkillList[j].rating;

                      let skillLevel = "";
                      if (candidateSkillList[j].skillLevel !== null) {
                        let skillLevelKey =
                          candidateSkillList[j].skillLevel.key;
                        skillLevel = skillLevelKey;
                      }

                      if (candidateSkillId == skill.skillId) {
                        if (candidateCategoryId == category.id) {
                          category.skills[indexval].isDisabled = false;
                          category.skills[indexval].rating =
                            candidateSkillRating;
                          category.skills[indexval].skillLevel = skillLevel;
                          const skillDetails = {
                            skillId: candidateSkillId,
                            categoryId: category.id,
                            skillLevel:skillLevel
                          };
                          updatedList.push(skillDetails);

                          let uniqueId = category.id + "_" + skill.skillId;
                          selectedRatingList.push({
                            skillId: skill.skillId,
                            rating: candidateSkillRating,
                            categoryId: category.id,
                            uniqueId: uniqueId,
                          });
                          candidateSelectedSkills.push({
                            skillId: skill.skillId,
                            skillLevel: skillLevel,
                            rating: candidateSkillRating,
                          });
                        } else {
                          category.skills[indexval].isDisabled = true;
                          category.skills[indexval].skillLevel = skillLevel;
                        }
                      }
                    }
                  } else {
                    category.skills[indexval].isDisabled = false;
                  }
                }
              });
          });
      });
      setSelectedSkills(candidateSelectedSkills);
      setRatingSelectedList(selectedRatingList);
      setSkillSelectedList(updatedList);
      setFilteredSkills(selectedSkillsList);
    } else {
      setSkillSelectedList([]);
      setFilteredSkills(selectedSkillsList);
    }
  };

  const seeFullList = () => {
    setlanguageShow((prev) => !prev);
    // setButtonShow((prev) => !prev);
    setFilteredSkills(categories);
    setSkillSelectedList([]);
  };

  const handleskills = (deleteId, name) => {
    setskillid(deleteId);
    setskillname(name);
  };

  const removeSkillDetails = () => {
    JobService.removeReqSkillsService(skillid, id).then((response) => {
      setCandidateSkills([]);
      toast.success("Skill deleted successfully");
      getReqSkillList();
    });
  };

  const setRatingValues = (skillId, categoryId) => {
    var uniqueId = categoryId + "_" + skillId;
    let ratingValue = 0;
    if (ratingSelectedList.length > 0) {
      const isFound = ratingSelectedList.some((element) => {
        if (element.categoryId === categoryId) {
          return true;
        }
        return false;
      });

      if (isFound) {
        const isSkillFound = ratingSelectedList.some((element) => {
          if (element.uniqueId === uniqueId) {
            return true;
          }
          return false;
        });
        if (isSkillFound) {
          for (let i = 0; i < ratingSelectedList.length; i++) {
            if (ratingSelectedList[i].uniqueId == uniqueId) {
              return ratingSelectedList[i].rating;
            }
          }
        } else {
          ratingValue = 0;
        }
      } else {
        ratingValue = 0;
      }
    } else {
      ratingValue = 0;
    }
  };

  const checkSkillStatus = (skillId, categoryId) => {
    var isSkillSelected = false;
    if (skillSelectedList.length > 0) {
      for (let i = 0; i < skillSelectedList.length; i++) {
        if (skillSelectedList[i].categoryId == categoryId) {
          if (skillSelectedList[i].skillId == skillId) {
            isSkillSelected = true;
          }
        }
      }
    }
    return isSkillSelected;
  };

  const skillLevelValue = (skillId, categoryId) => {
    let skillLevel = getEnumLists[0].key;
    for (var i = 0; i < selectedSkills.length; i++) {
      if (selectedSkills[i].skillId == skillId) {
        if (selectedSkills[i].categoryId == categoryId) {
          skillLevel = selectedSkills[i].skillLevel;
        }
      }
    }
    return skillLevel;
  };

  const isSkillDisabled = (skill) => {
    if (skill.isDisabled !== null) {
      if (skill.isDisabled) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  const resetSkillsList = () => {
    categories.length > 0 &&
      categories.map((industrydetails, index) => {
        industrydetails.categories.length > 0 &&
          industrydetails.categories.map((category, index) => {
            category.skills.length > 0 &&
              category.skills.map((skill, indexval) => {
                category.skills[indexval].rating = 0;
                category.skills[indexval].isDisabled = false;
                category.skills[indexval].skillLevel = "";
              });
          });
      });
    setCategories(categories);
    setFilteredSkills(categories);
  };

  const dailogerating = (skillId, categoryId) => {
    var uniqueId = categoryId + "_" + skillId;
    let ratingValue = 0;
    let isRated = false;
    if (ratingSelectedList.length > 0) {
      for (let i = 0; i < ratingSelectedList.length; i++) {
        if (ratingSelectedList[i].categoryId == categoryId) {
          if (ratingSelectedList[i].skillId == skillId) {
            ratingValue = ratingSelectedList[i].rating;
            //return showRatingFlavor(ratingValue);
            isRated = ratingSelectedList[i].isRated;
          }
        }
      }
    } else {
      ratingValue = 0;
    }

    if (isRated) {
      if (ratingValue == 1) {
        $("#" + skillId + categoryId + "ratingMessage")
          .fadeIn(1)
          .fadeOut(6000);
        return "Beginner";
      } else if (ratingValue == 2) {
        $("#" + skillId + categoryId + "ratingMessage")
          .fadeIn(1)
          .fadeOut(6000);
        return "Intermediate";
      } else if (ratingValue == 3) {
        $("#" + skillId + categoryId + "ratingMessage")
          .fadeIn(1)
          .fadeOut(6000);
        return "Proficient";
      } else if (ratingValue == 4) {
        $("#" + skillId + categoryId + "ratingMessage")
          .fadeIn(1)
          .fadeOut(6000);
        return "Advanced";
      } else if (ratingValue == 5) {
        $("#" + skillId + categoryId + "ratingMessage")
          .fadeIn(1)
          .fadeOut(6000);
        return "Expert";
      }
    }
  };

  return (
    <div>
      <div>
        <div className="skill-header">
          <div>
            <div className="profile-card-title">
              <label>
                <strong>
                  <h2>Skills</h2>
                </strong>
              </label>
            </div>
          </div>
          <div>
            {jobStatus != "CLOSED" && (
              <Button
                id="addSkill"
                color="primary"
                size="sm"
                outline
                onClick={onAddSkills}
              >
                Add Skills
              </Button>
            )}
          </div>
        </div>

        <div>
          <Modal
            scrollable={true}
            isOpen={modalRight}
            toggle={() => setModalRight(!modalRight)}
            wrapClassName="modal-right"
            className="skill-model-width"
          >
            <ModalHeader className="mdl_header">
              <div>
                <strong>Add and rate job skills</strong>
              </div>
            </ModalHeader>
            <ModalBody className="labelSize">
              <div className="col-lg-12 p-0">
                <Input
                  type="text"
                  icon="search"
                  placeholder="Search for skills"
                  onChange={(e) => searchItems(e.target.value)}
                />
              </div>

              {languageshow &&
                filteredSkills.length > 0 &&
                filteredSkills.map((industrydetails, index) => {
                  return (
                    <TreeView key={index}
                      nodeLabel={industrydetails.industry}
                      defaultCollapsed={false}
                      className="treeViewIconSize"
                    >
                      <div className="col ">
                        {industrydetails.categories.length > 0 &&
                          industrydetails.categories.map((category, index) => {
                            return (
                              <div key={index}>
                                {category.name == null ||
                                category.name == " " ? (
                                  <div>
                                    {category.skills.length > 0 &&
                                      category.skills.map((skill, index) => {
                                        return (
                                          <>
                                            <div className="col-12">
                                              <div className="row">
                                                <div className="col-sm-5">
                                                  <label
                                                    className={
                                                      skill.isDisabled
                                                        ? "terms disabled-checkbox"
                                                        : "terms"
                                                    }
                                                  >
                                                    <input
                                                      id="skill"
                                                      type="checkbox"
                                                      className="input_skill"
                                                      disabled={
                                                        skill.isDisabled
                                                      }
                                                      checked={checkSkillStatus(
                                                        skill.skillId,
                                                        category.id
                                                      )}
                                                      onChange={(e) =>
                                                        handleCheck(
                                                          e,
                                                          skill,
                                                          category.id
                                                        )
                                                      }
                                                    />{" "}
                                                    {skill.name}
                                                  </label>
                                                </div>

                                                {checkSkillStatus(
                                                  skill.skillId,
                                                  category.id
                                                ) ? (
                                                    <>
                                                      <div className="col-sm-4 mb-2">
                                                        <Input
                                                          width="5"
                                                          type="select"
                                                          id={
                                                            skill.skillId +
                                                            "_skillLevel"
                                                          }
                                                          onChange={(e) =>
                                                            handleSkillLevelChange(
                                                              e,
                                                              skill.skillId,
                                                              category.id
                                                            )
                                                          }
                                                          value={
                                                            skill.skillLevel
                                                          }
                                                        >
                                                          {jobSkillLevels.map(
                                                            ({
                                                              value,
                                                              key,
                                                            }) => (
                                                              <option
                                                                value={key}
                                                              >
                                                                {value}
                                                              </option>
                                                            )
                                                          )}
                                                        </Input>
                                                      </div>

                                                      <div className="col-sm-3">
                                                        <ReactStars
                                                          count={5}
                                                          size={24}
                                                          value={setRatingValues(
                                                            skill.skillId,
                                                            category.id
                                                          )}
                                                          id={
                                                            skill.skillId +
                                                            "_rating"
                                                          }
                                                          onChange={(e) =>
                                                            ratingChanged(
                                                              e,
                                                              skill.skillId,
                                                              category.id
                                                            )
                                                          }
                                                        />

                                                        <div
                                                          id={
                                                            skill.skillId +
                                                            category.id +
                                                            "ratingMessage"
                                                          }
                                                          className="t-text-[13px]"
                                                        >
                                                          {dailogerating(
                                                            skill.skillId,
                                                            category.id
                                                          )}
                                                        </div>
                                                      </div>
                                                    </>
                                                ) : (
                                                  <></>
                                                )}
                                              </div>
                                            </div>
                                          </>
                                        );
                                      })}
                                  </div>
                                ) : (
                                  <div>
                                    <TreeView
                                      nodeLabel={category.name}
                                      defaultCollapsed={false}
                                      className="treeViewIconSize"
                                    >
                                      <div>
                                        {category.skills.length > 0 &&
                                          category.skills.map(
                                            (skill, index) => {
                                              return (
                                                <div key={index}>
                                                  <div className="col-12">
                                                    <div className="row">
                                                      <div className="col-sm-5">
                                                        <label
                                                          className={
                                                            skill.isDisabled
                                                              ? "terms disabled-checkbox"
                                                              : "terms"
                                                          }
                                                        >
                                                          <input
                                                            id="skill"
                                                            type="checkbox"
                                                            className="input_skill"
                                                            disabled={
                                                              skill.isDisabled
                                                            }
                                                            checked={checkSkillStatus(
                                                              skill.skillId,
                                                              category.id
                                                            )}
                                                            onChange={(e) =>
                                                              handleCheck(
                                                                e,
                                                                skill,
                                                                category.id
                                                              )
                                                            }
                                                          />{" "}
                                                          {skill.name}
                                                        </label>
                                                      </div>

                                                      {checkSkillStatus(
                                                        skill.skillId,
                                                        category.id
                                                      ) ? (
                                                        <>
                                                          <>
                                                            <div className="col-sm-4 mb-2">
                                                              <Input
                                                                width="5"
                                                                type="select"
                                                                id={
                                                                  skill.skillId +
                                                                  "_skillLevel"
                                                                }
                                                                onChange={(e) =>
                                                                  handleSkillLevelChange(
                                                                    e,
                                                                    skill.skillId,
                                                                    category.id
                                                                  )
                                                                }
                                                                value={
                                                                  skill.skillLevel
                                                                }
                                                                // value={
                                                                //   "MUST_HAVE"
                                                                // }
                                                              >
                                                                {jobSkillLevels.map(
                                                                  ({
                                                                    value,
                                                                    key,
                                                                  }) => (
                                                                    <option
                                                                      value={
                                                                        key
                                                                      }
                                                                    >
                                                                      {value}
                                                                    </option>
                                                                  )
                                                                )}
                                                              </Input>
                                                            </div>

                                                            <div className="col-sm-3">
                                                              <ReactStars
                                                                count={5}
                                                                size={24}
                                                                value={setRatingValues(
                                                                  skill.skillId,
                                                                  category.id
                                                                )}
                                                                id={
                                                                  skill.skillId +
                                                                  "_rating"
                                                                }
                                                                onChange={(e) =>
                                                                  ratingChanged(
                                                                    e,
                                                                    skill.skillId,
                                                                    category.id
                                                                  )
                                                                }
                                                              />

                                                              <div
                                                                id={
                                                                  skill.skillId +
                                                                  category.id +
                                                                  "ratingMessage"
                                                                }
                                                                className="t-text-[13px]"
                                                                // className="t-status-size t-status-pad-st"
                                                              >
                                                                {dailogerating(
                                                                  skill.skillId,
                                                                  category.id
                                                                )}
                                                              </div>
                                                            </div>
                                                          </>
                                                        </>
                                                      ) : (
                                                        <></>
                                                      )}
                                                    </div>
                                                  </div>
                                                </div>
                                              );
                                            }
                                          )}
                                      </div>
                                    </TreeView>
                                  </div>
                                )}
                              </div>
                            );
                          })}
                      </div>
                    </TreeView>
                  );
                })}
              {filteredSkills.length == 0 && (
                <div className="t-nodata mt-4">
                  <strong>Skill not found</strong>
                </div>
              )}
            </ModalBody>
            <ModalFooter className="p-4">
              <Button color="primary" size="sm" outline onClick={updateSkills}>
                Save
              </Button>{" "}
              <Button
                color="primary"
                size="sm"
                outline
                onClick={() => setModalRight(false)}
              >
                Cancel
              </Button>
            </ModalFooter>
          </Modal>
        </div>

        {candidateSkills.length > 0 && (
          <Card className="mt-4">
            <CardBody>
              {candidateSkills.map((skill, index) => {
                return (
                  <div key={index} className="col mt-1">
                    <div className="col-12">
                      <div className="row">
                        <div className="col-sm-4">
                          <div className="tracbox">
                            <label>
                              <div className="terms">{skill.name}</div>
                            </label>
                          </div>
                        </div>
                        <div className="col-sm-3">
                          <div className="tracbox">
                            <label>
                              <div className="terms">
                                {skill.skillLevel.value}
                              </div>
                            </label>
                          </div>
                        </div>
                        <div className="col-sm-3">
                          <ReactStars
                            count={5}
                            size={18}
                            edit={false}
                            value={skill.rating}
                            id={skill.id + "_rating"}
                          >
                            onChange=
                            {(e) => ratingUpdatedChanged(e, skill)}
                          </ReactStars>
                        </div>
                        <div className="col-sm-2">
                          <Row>
                            {window.localStorage.getItem("view") === "view" ? (
                              <Link
                                className="disabledCursor ml-2"
                                onClick={(event) => event.preventDefault()}
                              >
                                <>
                                  <i className="emp_icon" />
                                </>
                              </Link>
                            ) : (
                              <div>
                                <span className="notDisabled ml-2 t-cursor-pointer">
                                  {jobStatus != "CLOSED" && (
                                    <>
                                      <i
                                        type="button"
                                        data-toggle="modal"
                                        data-target="#exampleModalcenter"
                                        className="mb-2 simple-icon-trash edit-copyiconsize arrow-icon-color mr-1 emp_icon"
                                        onClick={() =>
                                          handleskills(skill.id, skill.name)
                                        }
                                      />
                                    </>
                                  )}
                                </span>
                                <div
                                  className="modal fade mt-5"
                                  id="exampleModalcenter"
                                  tabIndex="-1"
                                  role="dialog"
                                  aria-labelledby="exampleModalLabelcenter"
                                  aria-hidden="true"
                                >
                                  <div className="modal-dialog" role="document">
                                    <div className="modal-content">
                                      <div className="modal-body">
                                        <h3>
                                          Do you want to delete{" "}
                                          <strong>
                                            {" " + skillname + " "}
                                          </strong>
                                          skill?
                                        </h3>
                                      </div>

                                      <div className="modal-footer p-3">
                                        <Button
                                          type="button"
                                          color="primary"
                                          size="sm"
                                          outline
                                          data-dismiss="modal"
                                        >
                                          Close
                                        </Button>
                                        <Button
                                          type="button"
                                          color="primary"
                                          size="sm"
                                          outline
                                          data-dismiss="modal"
                                          onClick={() => {
                                            removeSkillDetails();
                                          }}
                                        >
                                          Delete
                                        </Button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </Row>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </CardBody>
          </Card>
        )}
      </div>
    </div>
  );
};

export default Skills;
